import React from 'react';

const TimelineItem = ({ event, onClick }) => {

  const date = new Date(event.date);

  const formattedDate = date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  return (
    <div className="relative">
        <p className="text-sm font-semibold text-gray-600 dark:text-gray-300">{event.name} - {event.description}</p>
        <p className="text-xs text-gray-500">{formattedDate}</p>
    </div>
  );
};

export default TimelineItem;
